var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col",style:({'--width': _vm.width, '--md-width': _vm.mdWidth || _vm.width, '--sm-width': _vm.smWidth || _vm.mdWidth || _vm.width})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }